import { LoadableList } from "external/immutability-helper"
import { Context } from "./context"
import { Package } from "./package"

export type User = {
    index: number
    id: string
    username: string
    password: string
    name: string
    first_name: string
    last_name: string
    email: string
    phone: string
    packages: number
}

export type UserProfile = {
    id: string
    newPassword: string
    confirmPassword: string
    validatePassword: string
    first_name: string
    last_name: string
    email: string
    phone: string
}

export type PackageUser = {
    id: string
    first_name: string
    last_name: string
}

export type UserPackageDetails = Package & {
    courses: Array<PackageCourse>
}

export type PackageCourse = {
    id: string
    name: string
}

export const emptyUser: User = {
    id: '',
    index: -1,
    username: '',
    password: '',
    name: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    packages: 0
}

export const clearedSupportForm = {  name: '', email: '', id: '', message: '' }
export const clearedEditUser = {open: false, user: emptyUser}
export const clearedUserProfile =  { id: '', newPassword: '', confirmPassword: '', validatePassword: '', first_name: '', last_name: '', email: '', phone: '' }

export const emptyPasswords = { oldPassword: '', password: '', confirmPassword: ''}
export const clearedProfilePasswords = {open: false, passwords: emptyPasswords}

export type SavingMap = {
    [Property: string] : {
        [SavingProperty: string]: boolean
    }
}

export const clearedChangePaymentMethod = { error: '' }

export type ParentState = {
    homeData: {},
    supportForm: typeof clearedSupportForm
    userProfile: UserProfile
    users: LoadableList<User>
    payments: LoadableList<any>
    paymentHistory: LoadableList<any>
    paymentHistorySubscription: any
    paymentDetailIndex: false | number
    changePaymentMethodIndex: false | number
    saving: SavingMap
    userPackageDetailsProfile: false | User
    userPackageDetails: LoadableList<UserPackageDetails>
    modals: {
        addUser: typeof emptyUser,
        editUser: typeof clearedEditUser,
        updatePassword: typeof clearedProfilePasswords
        changePaymentMethod: typeof clearedChangePaymentMethod
    }
}

export type ParentContext = Context<ParentState>